//import { formatJsonLocation as fjl, formatLocation } from "../../components/renderers";
import { formatJsonLocation as fjl } from "../../components/renderers";
import { formatJsonDataset as fjd } from "../../components/renderers";

//const xlsaccept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';

export const platformconfig = {

  issue: {
    //fieldTypes: {tf:'',ta:'',nf:'',df:'',cf:'',rf:'',cb:'',fa:'',rb:'',if:'',ff:''},
    service:{
      name:'issue',
      title:'Issue',
      key:'rid',
      num: false,
      fields:['rid','nam','shc','dsc','evi','evn','evc','qmi','qmn','qmc','cri','thr','exi','sts','ast','stp'],
      grid  : [['nam','Name'],['shc','Code'],['dsc','Description'],['evc','Event'],['qmc','Requirement'],['cri','Criteria'],['thr','Thresholds'],['exi','Extra'],['sts','Status'],['stp','Stamp']],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
      eform:[
        {id:'nam',label:'Name',type:'tf',req:1,ops:{}},
        {id:'shc',label:'Shortcode',type:'tf',req:1,ops:{}},
        {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
        {id:'evi',label:'Event',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'event'}},
        {id:'qmi',label:'Requirement',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'requirement'}},
        {id:'cri',label:'Criteria',type:'tf',req:0,ops:{}},
        {id:'thr',label:'Threshold',type:'tf',req:0,ops:{}},
        {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{}},
        {id:'sts',label:'Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
        {id:'stp',label:'Stamp',type:'rf',req:0,ops:{}}
      ],
    },
    create:true,
    //actions: {add:'Add',view:'View'},
    //panels: {add:'simple',view:'simple'}
    actions: {add:'Add',edit:'Edit',delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  },

  device: {
    service: {
      name: 'device',
      title: 'Device',
      key: 'rid',
      num: true,
      fields: ['rid','dvn','dvk','dvc','dvm','dsc','dti','dtn','dtc','eni','enm','enc','lci','lcn','lcc','geo','dcd','exi','sts','ast','stp'],
      params: {dvn:'Name',dvk:'Devicekey',dvc:'Devicecode',dvm:'Devicemask',dsc:'Description',dti:'Type',eni:'Entity',lci:'Location',dcd:'Created',geo:'Geocode',exi:'Extrainfo',sts:'Status'},
      grid: [['dvn','Name'],['dvk','Key'],['dvc','Code'],['dvm','Mask'],['dsc','Description'],['dtc','Type'],['enc','Entity'],['lcn','Location'],['geo','Geocode'],['dcd','Created'],['exi','Extra'],['sts','Status'],['stp','Stamp']],
		  bar: {pag:true,btn:['add','edit','del','view']},
      menu: {mnu:[{t:'Name',v:'dvn'},{t:'Code',v:'shc'}],def:'nam'},
      eform:[{id:'dvn',label:'Name',type:'tf',req:1,ops:{}},
        {id:'dvk',label:'Key',type:'tf',req:1,ops:{}},
        {id:'dvc',label:'Code',type:'tf',req:1,ops:{}},
        {id:'dvm',label:'Mask',type:'nf',req:1,ops:{}},
        {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
        {id:'dti',label:'Type',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'devicetype'}},
        {id:'eni',label:'Entity',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'entity'}},
        {id:'lci',label:'Location',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'location'}},
        {id:'geo',label:'Geocode',type:'gl',req:0,ops:{},off:['add','edit']},
        {id:'dcd',label:'Created',type:'rf',req:0,ops:{}},
        {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{}},
        {id:'sts',label:'Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
      ],
    },
    create:false,
    actions: {del:'Delete',delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'viewer'},
    formatters: {grid: {geo:fjl,exi:fjd}}
  },


  house: {
    service:{
      name:'house',
      title:'Houses',
      num: true,
      fields:['rid','nam','shc','dsc','vti','vtn','vtc','ord','exi','sts','ast','stp'],
      params: {nam:'Name',shc:'Code',dsc:'Description',vti:'Type',sts:'Status'},
      
      grid: [['nam','Event'],['shc','Shortcode'],['dsc','Description'],['vtc','Type'],['ord','Order'],['exi','Extra Info'],['sts','Status'],['stp','Stamp']],
		  bar: {pag:true,btn:['view']},
      menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
      eform:[{id:'nam',label:'Name',type:'tf',req:1,ops:{}},
        {id:'shc',label:'Shortcode',type:'tf',req:1,ops:{}},
        {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
        {id:'vti',label:'Type',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'eventtype'}},
        {id:'ord',label:'Order',type:'nf',req:0,ops:{}},
        {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{}},
        //{id:'dtl',label:'Details',type:'rf',req:0,ops:{}},
        {id:'sts',label:'Record Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
        //{id:'stp',label:'Last Updated',type:'rf',req:0,ops:{}},
      ],
    },
    create:false,
    actions: {view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {exi:fjd}}
  },
  logger: {
    service:{
      name:'logger',
      title:'Event Logs',
      num: true,
      fields:['rid','tri','vno','dvi','dvn','dvc','eni','enc','loi','geo','dcd','exi','sts','ast','stp'],
      grid  : [['tri','TrackId'],['vno','Version'],['dvn','Device'],['enc','Entity'],['geo','Geocode'],['dcd','Created'],['exi','Extrainfo'],['sts','Status'],['stp','Stamp']],
      menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
      eform:[
        {id:'tri',label:'Tracking Id',type:'rf',req:0,ops:{}},
        {id:'vno',label:'Version',type:'rf',req:0,ops:{}},
        {id:'dvn',label:'Device',type:'rf',req:0,ops:{}},
        {id:'enc',label:'Entity',type:'rf',req:0,ops:{}},
        {id:'geo',label:'Geocode',type:'rf',req:0,ops:{}},
        {id:'dsc',label:'Description',type:'rf',req:0,ops:{}},
        {id:'dcd',label:'Created',type:'rf',req:0,ops:{}},
        {id:'exi',label:'Extrainfo',type:'rf',req:0,ops:{}},
        {id:'stp',label:'Stamp',type:'rf',req:0,ops:{}}
      ],
    },
    create:false,
    panels: { 
      view:'simple',close:'dialog',check:'dialog',print:'result'
    },
    formatters: {grid: {req:fjd,res:fjd,exi:fjd}}
  },

  notification: {
    service:{
      name:'notification',
      title:'Event Notification',
      num: true,
      fields:['rid','tri','sen','rcp','msg','nti','ntc','nsi','nsc','rqi','rfn','dsc','dcd','exi','usi','sts','ast','stp'],
      grid  : [['tri','TrackId'],['sen','Sender'],['rcp','Recipient'],['msg','Message'],['ntc','Type'],['nsc','State'],['rfn','Reference'],['dsc','Description'],['dcd','Created']],
      menu: {mnu:[{t:'Auditee',v:'usi'}],def:'usi'},
      eform:[
        {id:'tri',label:'Track ID',type:'rf',req:0,ops:{}},
        {id:'sen',label:'Sender',type:'rf',req:0,ops:{}},
        {id:'rcp',label:'Recipient',type:'rf',req:0,ops:{}},
        {id:'msg',label:'Message',type:'rf',req:0,ops:{}},
        {id:'ntc',label:'Type',type:'rf',req:0,ops:{}},
        {id:'nsc',label:'State',type:'rf',req:0,ops:{}},
        {id:'rfn',label:'Request',type:'rf',req:0,ops:{}},
        {id:'rvd',label:'Review',type:'rf',req:0,ops:{}},
        {id:'dsc',label:'Description',type:'rf',req:0,ops:{}},
        {id:'dcd',label:'Created',type:'rf',req:0,ops:{}},
        {id:'exi',label:'Extrainfo',type:'rf',req:0,ops:{}},
        {id:'sts',label:'Status',type:'rf',req:0,ops:{}},
        {id:'stp',label:'Stamp',type:'rf',req:0,ops:{}}
      ],
    },
    create:false,
    panels: { 
      view:'simple',close:'dialog',check:'dialog',print:'result'
    },
    //formatters: {grid: {req:fjd,res:fjd,exi:fjd}}
  },

  //   activity
  // customer
  // device
  // event
  //logger
  //notification
  //register
  //request
  //review

};
